import instance from "../../index";
import {BaseResponse} from "../../../models/base-response";
import {BackofficeUserPasswordResult} from "../../../models/backoffice-user-password-result";
import {ChangeBackofficeUserPasswordRequest} from "../../../models/requests/change-backoffice-user-password-request";

export async function resetBackofficeUserPassword(id: string): Promise<BackofficeUserPasswordResult> {
    const response = await instance.put<BaseResponse<BackofficeUserPasswordResult>>(
        `/v1/backoffice/backoffice-users/${id}/reset-password`
    );
    return response.data.data;
}

export async function changeBackofficeUserPassword(
    id: string,
    request: ChangeBackofficeUserPasswordRequest
): Promise<BackofficeUserPasswordResult> {
    const response = await instance.put<BaseResponse<BackofficeUserPasswordResult>>(
        `/v1/backoffice/backoffice-users/${id}/password`,
        request
    );
    return response.data.data;
}
